import $ from 'jquery';
import getProduct from './getProduct';

const QuickView = () => {
  
  $(document).on('click', '[data-quick-view-button]', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const product_url = $(e.currentTarget).closest('a').attr('href');

    getProduct(product_url);
  });

  // Handle external/split PDP's or other product links from inside of modals
  $(document).on('click', '[data-quick-view-content] a:not([data-quickview-ignore])', (e) => {
    const $link = $(e.currentTarget);

    if (!$link.attr('href') || ($link.attr('href') && $link.attr('href').indexOf('/products/') === -1)) { return; }

    e.preventDefault();
    getProduct($link.attr('href'));
  });

};

export {
  QuickView,
};